export var createMuiListItemIconOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            color: palette.text.secondary,
            minWidth: spacing(8),
            minHeight: spacing(8),
            alignItems: "center",
            justifyContent: "center",
        },
        alignItemsFlexStart: {
            marginTop: undefined,
        },
    });
};
//# sourceMappingURL=MuiListItemIcon.js.map